import hocify from 'hocify';
import useSharedRef from 'react-use-shared-ref';

export default hocify(() => {
  const { refs } = useSharedRef();
  return { refs };
});
